<div class="tile-padding-first tile-padding">
  @if (showHeader) {
    <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
      <div class="tw:flex-1 tw:px-[15px]">
        <h3>FAQs</h3>
      </div>
      <div class="tw:flex-1 tw:px-[15px]">
        <div class="faq-icon-container tw:flex tw:items-center cursor-pointer" (click)="showModalTest()">
          <div class="faq-icon cursor-pointer">
          </div>
        </div>
      </div>
    </div>
  }

  <div class="tw:mt-4">

    <mat-accordion>

      @for (faq of faqs; track faq) {
        <mat-expansion-panel class="mat-expansion-panel-spacing">
          <mat-expansion-panel-header (click)="openFaq(faq)">
            <mat-panel-title>
              <h5 class="panel-title">{{faq.title}}</h5>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <faq-answers [faqAnswers]="faq.answers"></faq-answers>
        </mat-expansion-panel>
      }

    </mat-accordion>

  </div>
</div>
